export function messageRequestEvent(params) {
    return new CustomEvent("growtypeChatMessageRequestEvent", {
        detail: params
    });
}
